import { MdCheckCircle, MdEmail, MdExpandLess, MdExpandMore, MdPhone, MdSelfImprovement } from "react-icons/md";
import Card from "components/card";
import Badge from "components/badge/Badge";
import Button from "components/button";
import { formatDate, formatRelative } from "utils/format";
import { getPrayerStatusMeta } from "./actionItemMeta";

const CLAMP_LENGTH = 200;

const contactLinkClass =
  "focus-ring flex items-center gap-1 rounded-sm text-primary hover:underline dark:text-accent";

const PrayerRequestRow = ({ prayer, expanded, onToggleExpand, onMarkAnswered }) => {
  const status = getPrayerStatusMeta(prayer.isAnswered);
  const isLong = prayer.prayerRequest?.length > CLAMP_LENGTH;

  return (
    <Card padding="sm">
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div className="flex min-w-0 items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-control bg-brand-100 text-brand-800 dark:bg-brand-900/40 dark:text-brand-200">
            <MdSelfImprovement aria-hidden="true" className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="text-base font-semibold text-fg">
                {prayer.requesterName || "Anonymous"}
              </h2>
              <Badge tone={status.tone}>{status.label}</Badge>
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-fg-muted">
              <span>{formatRelative(prayer.submittedAt)}</span>
              {prayer.requesterEmail && (
                <a href={`mailto:${prayer.requesterEmail}`} className={contactLinkClass}>
                  <MdEmail aria-hidden="true" className="h-4 w-4" />
                  {prayer.requesterEmail}
                </a>
              )}
              {prayer.requesterPhone && (
                <a href={`tel:${prayer.requesterPhone}`} className={contactLinkClass}>
                  <MdPhone aria-hidden="true" className="h-4 w-4" />
                  {prayer.requesterPhone}
                </a>
              )}
            </div>
          </div>
        </div>

        {prayer.isAnswered ? (
          <Button variant="secondary" size="sm" onClick={() => onMarkAnswered(false)}>
            Reopen
          </Button>
        ) : (
          <Button
            size="sm"
            leftIcon={<MdCheckCircle aria-hidden="true" />}
            onClick={() => onMarkAnswered(true)}
          >
            Mark Answered
          </Button>
        )}
      </div>

      <div className="mt-4 rounded-control bg-surface-subtle p-4">
        <p className={`text-sm text-fg ${isLong && !expanded ? "line-clamp-3" : ""}`.trim()}>
          "{prayer.prayerRequest}"
        </p>
        {isLong && (
          <Button
            variant="ghost"
            size="sm"
            className="-ml-3 mt-2"
            aria-expanded={Boolean(expanded)}
            leftIcon={
              expanded ? <MdExpandLess aria-hidden="true" /> : <MdExpandMore aria-hidden="true" />
            }
            onClick={onToggleExpand}
          >
            {expanded ? "Show Less" : "Read More"}
          </Button>
        )}
      </div>

      {prayer.isAnswered && prayer.answeredAt && (
        <p className="mt-3 flex items-center gap-2 text-sm text-fg-muted">
          <MdCheckCircle aria-hidden="true" className="h-4 w-4 text-success-fg" />
          <span>
            Answered on {formatDate(prayer.answeredAt)}
            {prayer.answeredByName && (
              <span className="font-medium text-fg"> by {prayer.answeredByName}</span>
            )}
          </span>
        </p>
      )}
    </Card>
  );
};

export default PrayerRequestRow;
